import { InlineInternalOnlyBadge } from '@orn/shared-web/components/InternalOnlyBadge';
import { ChevronLeftIcon, CodeIcon } from '@orn/shared-web/icons';
import { cx } from '@orn/shared-web/utils/cx';
import * as React from 'react';

import { filterNullsAndUndefined } from '../../../utils/apollo/filterUtils';

interface IJsonDebugRowProps {
  label: string;
  rawJson: unknown;
}

const JsonDebugRow = ({ label, rawJson }: IJsonDebugRowProps) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  if (!rawJson) {
    return null;
  }

  return (
    <div className="min-h-18 flex flex-col gap-2 px-4 py-6">
      <div
        onClick={() => setIsExpanded(!isExpanded)}
        className="text-md text-tertiary flex w-full flex-1 cursor-pointer items-center gap-1 font-medium"
      >
        <CodeIcon className="size-4.5 shrink-0" />
        {label}
        <InlineInternalOnlyBadge />
        <ChevronLeftIcon
          className={cx(
            'text-quaternary size-4.5 ml-auto shrink-0 transition-transform duration-200',
            isExpanded && '-rotate-90'
          )}
        />
      </div>
      {isExpanded && (
        <pre className="bg-secondary_subtle m-0 max-h-96 overflow-auto whitespace-pre-wrap rounded-lg p-3 text-xs">
          {JSON.stringify(filterNullsAndUndefined(rawJson), null, 2)}
        </pre>
      )}
    </div>
  );
};

export default JsonDebugRow;
